const jsonFileHandler = (data) => {
  return {
    collection: 'codigosCID',
    data: {
      id: data.codigo,
      name: data.nome,
    },
  };
};

export default jsonFileHandler;
